import actionTypes from '../constants/actionTypes';
import { getClosureItems, getClosureStats, getClosureTransactions } from '../../../../services/accounting/closures';

export const getClosureStatsAction = (closureId) => async (dispatch) => {
  const { CLOSURE_STATS_DATA_FETCH, CLOSURE_STATS_DATA_SUCCESS, CLOSURE_STATS_DATA_ERROR } = actionTypes;
  dispatch({ type: CLOSURE_STATS_DATA_FETCH });
  try {
    const payload = await getClosureStats(closureId);
    dispatch({ type: CLOSURE_STATS_DATA_SUCCESS, payload: payload });
  } catch (error) {
    const errorResponse = error.response;
    dispatch({ type: CLOSURE_STATS_DATA_ERROR, error: errorResponse });
  }
};

export const getClosureTransactionsAction = (closureId, page, pageSize) => async (dispatch) => {
  const { CLOSURE_TRANSACTIONS_FETCH, CLOSURE_TRANSACTIONS_SUCCESS, CLOSURE_TRANSACTIONS_ERROR } = actionTypes;
  dispatch({ type: CLOSURE_TRANSACTIONS_FETCH });
  try {
    const payload = await getClosureTransactions(closureId, page, pageSize);
    dispatch({ type: CLOSURE_TRANSACTIONS_SUCCESS, payload: payload });
  } catch (error) {
    const errorResponse = error.response;
    dispatch({ type: CLOSURE_TRANSACTIONS_ERROR, error: errorResponse });
  }
};

export const getClosureItemsAction = (closureId, page, pageSize) => async (dispatch) => {
  const { CLOSURE_ITEMS_FETCH, CLOSURE_ITEMS_SUCCESS, CLOSURE_ITEMS_ERROR } = actionTypes;
  dispatch({ type: CLOSURE_ITEMS_FETCH });
  try {
    const payload = await getClosureItems(closureId, page, pageSize);
    dispatch({ type: CLOSURE_ITEMS_SUCCESS, payload: payload });
  } catch (error) {
    const errorResponse = error.response;
    dispatch({ type: CLOSURE_ITEMS_ERROR, error: errorResponse });
  }
};
